import React, { useEffect, useState } from 'react';
import { safeGetItem } from '/Foundation/React/code/Utilities/LocalStorage';
import { useDispatch } from 'react-redux';
import Notification from './Notifications/Notification';
import { getFormattedPrice } from '../../../Utils/Utils';
import { changeProductAmount, removeProduct } from '../../../Helpers/ProductQuantityHelper';

export default function CartLine(props) {
  const dispatch = useDispatch();
  const [pendingRemovedProduct, setPendingRemovedProduct] = useState(false);
  const [qtyButtonsDisabled, setQtyButtonsDisabled] = useState(false);
  const [currentQty, setCurrentQty] = useState(props.product.quantity);

  const { product, isThule, currencyCode, cartPageData, customHandleRemoveProduct, customAfterQuantityUpdate } = props;

  const {
    image,
    productImageDescription,
    webtitle1,
    isInStock,
    price,
    discountedPrice,
    messages,
    quantity,
    webtitle2,
    id,
    key,
    productType,
    originalUnitPrice,
    discountedUnitPrice,
    isFreeGift,
  } = product;

  const formattedOriginalPrice = getFormattedPrice(price, currencyCode);
  const formattedDiscountedPrice = getFormattedPrice(discountedPrice, currencyCode);

  useEffect(() => {
    setCurrentQty(props.product.quantity);
  }, [props.product.quantity]);

  const handleChange = async (newqty) => {
    if (newqty >= 1) {
      if (id && newqty && newqty > 0) {
        setQtyButtonsDisabled(true);
        setCurrentQty(newqty);
        const result = await dispatch(
          changeProductAmount({
            externalId: id,
            amount: newqty,
            adobeAnalyticsData: getAdobeAnalyticsData(),
          })
        );
        setQtyButtonsDisabled(false);
        if (customAfterQuantityUpdate) customAfterQuantityUpdate(result);
      }
    }
  };

  const handleRemove = (e) => {
    e.target.setAttribute('disabled', true);
    setPendingRemovedProduct(true);
    const adobeAnalyticsData = getAdobeAnalyticsData();
    if (customHandleRemoveProduct) {
      customHandleRemoveProduct(id, adobeAnalyticsData);
    } else {
      dispatch(removeProduct({ externalId: id, adobeAnalyticsData: adobeAnalyticsData }));
    }
  };

  const getAdobeAnalyticsData = () => {
    const analyticsData = safeGetItem('analytics.categories');
    let analyticsEntry;
    if (analyticsData) analyticsEntry = analyticsData[key];
    const adobeAnalyticsData = {};
    adobeAnalyticsData.products = [
      {
        id: id,
        name: webtitle1,
        over_category: analyticsEntry?.Overcategoryanalytics,
        subcategory: analyticsEntry?.Subcategoryanalytics,
        category: analyticsEntry?.Categoryanalytics,
        colour: analyticsEntry?.ColorSpecification,
        price: discountedUnitPrice !== null ? `${discountedUnitPrice}` : `${originalUnitPrice}`,
        original_price: `${originalUnitPrice}`,
      },
    ];

    return adobeAnalyticsData;
  };

  const productUrl = `/${window._THULEDATA.SitecoreLanguage.toLowerCase()}/${
    productType?.toLowerCase() === 'spare part' || productType?.toLowerCase() === 'accessory' ? 'accessories/' : ''
  }-_-${key}`;

  return (
    <div
      className={
        'product-container d-flex py-6 ' + (isInStock ? '' : 'invalid') + (pendingRemovedProduct ? 'loading' : '')
      }
    >
      <a href={productUrl} className="me-3 me-lg-4">
        <div className={'product-image ' + (isThule ? 'use-bg' : '')}>
          {image && <img src={image} alt={productImageDescription || webtitle1} />}
        </div>
      </a>
      <div className="flex-1 product-content">
        <div className={'d-flex ' + (!isInStock ? 'strike-through' : '')}>
          <div className="product-info flex-1 mb-6 mb-lg-0">
            <a href={productUrl}>
              <div className="product-detail name link mb-1 product-heading">{webtitle1}</div>
              <div className="product-detail name link paragraph--xs text-color--gray80">{webtitle2}</div>
            </a>
          </div>
          <div className="d-flex flex-column align-items-end">
            <div className="ms-7">
              <div className="product-detail line-total product-heading price-value">
                {formattedDiscountedPrice || formattedOriginalPrice}
              </div>
              {discountedPrice !== null && (
                <div className="product-detail line-through-text text-color--gray60 product-heading price-value">
                  {formattedOriginalPrice}
                </div>
              )}
            </div>
            {isFreeGift && <span className="free-gift-text paragraph--xs">{cartPageData.freeGift}</span>}
          </div>
        </div>
        {!isInStock && (
          <div className="mb-3 mt-lg-3 mb-lg-0">
            <Notification
              Type={'error'}
              Size={'sm'}
              Message={cartPageData.outOfStockText}
              HideCloseBtn={true}
              ShowIcon={true}
            />
          </div>
        )}
        {messages?.map((message, i) => (
          <div className="mb-3 mt-lg-3 mb-lg-0" key={i}>
            <Notification Type={'neutral'} Size={'sm'} Message={message} HideCloseBtn={true} ShowIcon={true} />
          </div>
        ))}
        <div className="d-flex bottom-section mt-lg-7">
          <div className="d-flex picker-wrapper">
            <button
              onClick={(e) => {
                e.preventDefault();
                if (!qtyButtonsDisabled) {
                  handleChange(parseInt(currentQty, 10) - 1);
                }
              }}
              className={
                'picker minus rpa-decrease-quantity ' + (quantity == 1 || qtyButtonsDisabled ? 'disabled' : '')
              }
              disabled={qtyButtonsDisabled}
            >
              <i className="le-icon-minus"> </i>
              <span className="sr-only">Decrease quantity of product by one</span>
            </button>
            <div className={'qty mx-2 ' + (qtyButtonsDisabled ? 'disabled' : '')}>{isFreeGift ? 1 : currentQty}</div>
            <button
              onClick={(e) => {
                e.preventDefault();
                if (!qtyButtonsDisabled && isInStock) {
                  handleChange(parseInt(currentQty, 10) + 1);
                }
              }}
              className={'picker plus rpa-increase-quantity ' + (qtyButtonsDisabled || !isInStock ? 'disabled' : '')}
              disabled={qtyButtonsDisabled || !isInStock}
            >
              <i className="le-icon-plus"> </i>
              <span className="sr-only">Increase quantity of product by one</span>
            </button>
          </div>
          <button className="no-button-styling remove-product-button px-0" onClick={(e) => handleRemove(e, id)}>
            {cartPageData.remove}
          </button>
        </div>
      </div>
    </div>
  );
}
